import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCloseGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M9.99967 11.1666L5.91634 15.25C5.76356 15.4028 5.56912 15.4791 5.33301 15.4791C5.0969 15.4791 4.90245 15.4028 4.74967 15.25C4.5969 15.0972 4.52051 14.9028 4.52051 14.6666C4.52051 14.4305 4.5969 14.2361 4.74967 14.0833L8.83301 9.99998L4.74967 5.91665C4.5969 5.76387 4.52051 5.56942 4.52051 5.33331C4.52051 5.0972 4.5969 4.90276 4.74967 4.74998C4.90245 4.5972 5.0969 4.52081 5.33301 4.52081C5.56912 4.52081 5.76356 4.5972 5.91634 4.74998L9.99967 8.83331L14.083 4.74998C14.2358 4.5972 14.4302 4.52081 14.6663 4.52081C14.9025 4.52081 15.0969 4.5972 15.2497 4.74998C15.4025 4.90276 15.4788 5.0972 15.4788 5.33331C15.4788 5.56942 15.4025 5.76387 15.2497 5.91665L11.1663 9.99998L15.2497 14.0833C15.4025 14.2361 15.4788 14.4305 15.4788 14.6666C15.4788 14.9028 15.4025 15.0972 15.2497 15.25C15.0969 15.4028 14.9025 15.4791 14.6663 15.4791C14.4302 15.4791 14.2358 15.4028 14.083 15.25L9.99967 11.1666Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconCloseSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...(props.svg ?? {})}
    >
      <IconCloseGroup {...props} />
    </svg>
  );
};
